import { Stack } from '@talentmesh/core';
import { DeleteOutlineIcon, EditIcon } from '@talentmesh/icons';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { EducationFormValues } from '../../../../../MyAssessment/ProfileSettings/utils/ApplicantProfileUtils';
import CustomIconButton from '../../../Components/CustomIconButton';
import EducationsFieldsNames from '../../EducationsFieldsNames';

interface ToolbarProps {
    index: number;
    onRemove: () => void;
    onEdit: (isInEdit: boolean, experience: EducationFormValues) => void;
}

const Toolbar: React.FC<ToolbarProps> = ({ index, onRemove, onEdit }) => {
    const { control } = useFormContext();
    const education: EducationFormValues = useWatch({
        control,
        name: `${EducationsFieldsNames.EducationsName}.${index}`,
    });

    return (
        <Stack direction="row">
            <CustomIconButton
                data-cy="edit"
                onClick={() => {
                    // need to clone an object here
                    // otherwise, the snapshot will get all resent updates.
                    onEdit(true, { ...education });
                }}
            >
                <EditIcon />
            </CustomIconButton>
            <CustomIconButton data-cy="delete" onClick={onRemove}>
                <DeleteOutlineIcon />
            </CustomIconButton>
        </Stack>
    );
};

export default Toolbar;
